import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  nClients: 0,
  clientIds: [],
  firmId: 0,
};

export const clientsInfoSlice = createSlice({
  name: 'clientsInfo',
  initialState: initialState,
  reducers: {
    clearClientsInfo: () => {
      return initialState;
    },

    setClientsInfo: (state, action) => {
      return action.payload;
    },

    addClientToClientsInfo: (state, action) => {
      const possiblyNewId = action.payload;
      if (state.clientIds.indexOf(possiblyNewId) < 0) {
        const newClientIds = state.clientIds.concat(possiblyNewId);
        const newNClients = state.nClients + 1;
        return { ...state, nClients: newNClients, clientIds: newClientIds };
      } else {
        return state;
      }
    },

    removeClientFromClientsInfo: (state, action) => {
      const idOfClientToRemove = action.payload;
      const origClientIds = state.clientIds;
      const indexOfClientToRemove = origClientIds.indexOf(idOfClientToRemove);
      if (indexOfClientToRemove >= 0) {
        const precedingClientIds = origClientIds.slice(0, indexOfClientToRemove);
        const succeedingClientIds = origClientIds.slice(indexOfClientToRemove + 1, origClientIds.length);
        const newClientIds = [...precedingClientIds, ...succeedingClientIds];
        const newNClients = state.nClients - 1;
        return { ...state, nClients: newNClients, clientIds: newClientIds };
      } else {
        return state;
      }
    },
  },
});

export const { clearClientsInfo, setClientsInfo, addClientToClientsInfo, removeClientFromClientsInfo } =
  clientsInfoSlice.actions;

export default clientsInfoSlice.reducer;
